export const Images = {
  logo: require('../assets/images/icon.png'),
  group: require('../assets/images/meetinggroups.png'),
  sun: require('../assets/images/suncorner.png'),
  trim: require('../assets/images/trim.png'),
  campfire: require('../assets/images/bluecampfire.png'),
};
